import getClassName from "../../utilities/getClassName";

const Label = ({ children, minimised, skipAnimation, htmlFor }) => {
    const classNames = ["label"];

    if (minimised) {
        classNames.push("label--minimised");
    }

    if (skipAnimation) {
        classNames.push("label--skip-animation");
    }

    return (
        <label className={getClassName(classNames)} htmlFor={htmlFor}>
            {children}
        </label>
    );
};

export default Label;
